import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials:true
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/signin';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
};

export const usersAPI = {
  getAll: (params) => API.get('/users', { params }),
  getMe: () => API.get('/users/me'),
  getById: (id) => API.get(`/users/${id}`),
  updateMe: (data) => API.put('/users/me', data),
};

export const swapsAPI = {
  getAll: () => API.get('/swaps'),
  create: (data) => API.post('/swaps', data),
  accept: (id) => API.put(`/swaps/${id}/accept`),
  reject: (id) => API.put(`/swaps/${id}/reject`),
  complete: (id) => API.put(`/swaps/${id}/complete`),
  delete: (id) => API.delete(`/swaps/${id}`),
};

export const messagesAPI = {
  getConversations: () => API.get('/messages/conversations'),
  getMessages: (userId) => API.get(`/messages/${userId}`),
  send: (data) => API.post('/messages', data),
};

export const resourcesAPI = {
  getAll: (params) => API.get('/resources', { params }),
  create: (data) => API.post('/resources', data),
  share: (id, userId) => API.put(`/resources/${id}/share`, { userId }),
  delete: (id) => API.delete(`/resources/${id}`),
};

export default API;
